var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('section',{class:_vm.$vuetify.breakpoint.name === 'xl' ? 'container' : ''},[_c('v-container',[_vm._v("\n      "+_vm._s(_vm.imageUrlToBase64(_vm.$route.query.url))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }